import * as React from "react";
import ScrollBar from "react-perfect-scrollbar";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilLoca } from "../../utils/i18n/utilLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalCloseLast } from "../modals/actionModal";
import { SunsettingImages } from "./SunsettingImages";
var _DialogSunsetting = function (_a) {
    var onClose = _a.onClose;
    var convertDate = getDate(utilLoca.getCurrentLanguage());
    var replacements = new Map([
        [ReplacementLoca.zero_0, convertDate(new Date(Date.UTC(2020, 9, 5, 12)))],
        [ReplacementLoca.one_1, "10 AM"],
    ]);
    return (React.createElement(DialogWrapper, { titleLocaId: "BFNH_Sunset_Title", onClose: onClose, className: IdStyles.ModalBackground },
        React.createElement("div", { className: "flex flex--centered flex--aligned flex--stacked" },
            React.createElement("div", { className: "sunsetting--text-container" },
                React.createElement(ScrollBar, { className: "flex flex--full sunsetting--text" },
                    React.createElement("div", { className: IdStyles.TextBoldPrimary + " show-list" },
                        React.createElement(TextLoca, { id: "BFNH_Sunset_Announcement2_line1", replacements: replacements }),
                        React.createElement("br", null),
                        React.createElement(SunsettingImages, null),
                        React.createElement("br", null),
                        React.createElement(TextLoca, { id: "BFNH_Sunset_Announcement2_line2", replacements: replacements })))))));
};
var getDate = function (language) { return function (date) {
    var options = { weekday: "long", year: "numeric", month: "numeric", day: "numeric" };
    return date.toLocaleString(language, options);
}; };
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalCloseLast()); },
}); };
export var DialogSunsetting = connect(undefined, mapDispatch)(_DialogSunsetting);



//////////////////
// WEBPACK FOOTER
// ./src/features/sunsetting/DialogSunsetting.tsx
// module id = 2933
// module chunks = 3